import {
  Button,
  Divider,
  Drawer,
  Popconfirm,
  Tag,
  Tree,
  Typography,
  message,
} from 'antd'
import { memo, useCallback, useEffect, useRef, useState } from 'react'

import {
  deleteTextbookCategory,
  getTextbookCategory,
} from '~/services/textbook-category'

import { ITextbookCategory } from '../../types/textbook-category'
import ModalForm from './ModalForm'
import { Container } from './style'

const Index = () => {
  const [loading, setLoading] = useState(false)
  const [dataSource, setDataSource] = useState<any[]>([])
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [drawerFormData, setDrawerFormData] = useState<
    Partial<ITextbookCategory>
  >({})

  const pageRef = useRef({
    page: 1,
    size: 100,
  })

  const fetchData = useCallback(() => {
    setLoading(true)
    setDataSource([])
    getTextbookCategory(pageRef.current.page, pageRef.current.size, 0)
      .then((res) => {
        setDataSource(
          (res.data?.content || []).map((item: any) => ({
            ...item,
            children: [],
          })),
        )
      })
      .catch((err) => {
        message.error(
          err?.response?.data || err?.message || '请求错误，请稍后再试',
        )
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const onSearch = useCallback(() => {
    fetchData()
  }, [fetchData])

  const addData = useCallback(() => {
    setDrawerFormData({
      parentId: 0,
      name: '',
      seriesName: '',
      remark: '',
    })
    setIsDrawerOpen(true)
  }, [])
  const closeDrawer = useCallback(() => {
    setDrawerFormData({})
    setIsDrawerOpen(false)
  }, [])

  const loadData = useCallback(async (item: { id: number }) => {
    return getTextbookCategory(1, 100, item.id)
      .then((res) => {
        const data = res.data.content || []
        setDataSource((pre) => {
          const category = pre.find((i) => i.id === item.id)
          if (category) {
            category.children = data.map((item: any) => ({
              ...item,
              isLeaf: true,
            }))
          }
          return [...pre]
        })
      })
      .catch((err) => {
        message.error(
          err?.response?.data || err?.message || '请求错误，请稍后再试',
        )
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  const deleteCategegory = useCallback((id: number, parentId: number) => {
    deleteTextbookCategory(id)
      .then(() => {
        if (parentId === 0) {
          setDataSource((pre) => {
            const nextData = pre.filter((item) => item.id !== id)
            return nextData
          })
        } else {
          setDataSource((pre) => {
            const parentNode = pre.find((item) => item.id === parentId)
            if (parentNode) {
              parentNode.children = parentNode.children.filter(
                (item: any) => item.id !== id,
              )
            }
            console.log([...pre])
            return [...pre]
          })
        }
      })
      .catch((err) => {
        message.error(
          err?.response?.data || err?.message || '请求错误，请稍后再试',
        )
      })
  }, [])

  const Node = useCallback(
    (props: {
      name: string
      parentId: number
      id: number
      language?: string
    }) => {
      const { name, parentId, id, language } = props
      return (
        <div>
          <span>{name}</span>
          {parentId !== 0 && language && (
            <Tag style={{ marginLeft: 8 }}>{language}</Tag>
          )}
          <Typography.Link
            style={{ marginLeft: 20 }}
            onClick={() => {
              setDrawerFormData({
                ...props,
                seriesName: '',
              })
              setIsDrawerOpen(true)
            }}
          >
            编辑
          </Typography.Link>
          <Divider type="vertical" />
          {parentId === 0 && (
            <>
              <Typography.Link
                onClick={() => {
                  setDrawerFormData({
                    parentId: id,
                  })
                  setIsDrawerOpen(true)
                }}
              >
                添加子分类
              </Typography.Link>
              <Divider type="vertical" />
            </>
          )}
          <Popconfirm
            title="确认删除？"
            okText="确认"
            cancelText="取消"
            onConfirm={() => {
              deleteCategegory(id, parentId)
            }}
          >
            <Typography.Link type="danger">删除</Typography.Link>
          </Popconfirm>
        </div>
      )
    },
    [deleteCategegory],
  )

  const addCallback = useCallback(() => {
    setIsDrawerOpen(false)
    fetchData()
  }, [fetchData])

  return (
    <Container>
      <div className="top">
        <Button
          style={{ marginRight: 12 }}
          type="primary"
          loading={loading}
          onClick={onSearch}
        >
          查询
        </Button>
        <Button onClick={addData}>新增</Button>
      </div>
      <div className="table">
        <Tree
          treeData={dataSource}
          fieldNames={{ title: 'name', key: 'id' }}
          selectable={false}
          loadData={loadData}
          titleRender={Node}
        />
      </div>
      <div className="pagination"></div>
      <Drawer
        title={drawerFormData.id ? '编辑分类' : '新增分类'}
        open={isDrawerOpen}
        onClose={closeDrawer}
        width={450}
        destroyOnClose
      >
        <ModalForm data={drawerFormData} addCallback={addCallback} />
      </Drawer>
    </Container>
  )
}

export default memo(Index)
